





























import Vue from "vue";
import Component from "vue-class-component";
import Calendar from "@/components/Calendar.vue";
import moment from "moment";
import { Watch } from "vue-property-decorator";
import { Tutorial } from "./TutorialsAdmin.vue";

export interface TutorSession {
  id: number;
  group: string;
  name: string;
  day: string;
  start: string;
  end: string;
  status: string;
  participants: number | undefined;
  tutor: number;
  link?: string;
  password?: string;
}

@Component({
  components: { Calendar },
})
export default class Tutorials extends Vue {
  selectedWeek = "";
  sessionsWeek: TutorSession[] = [];
  sessionsWeekDict: { [key: string]: TutorSession[] } = {};
  capacityDict: { [key: number]: any } = {};
  tutors: any[] = [];

  created() {
    this.selectedWeek = this.getMondayString(moment());
  }

  data() {
    return {
      items: [
        {
          text: this.getWeekString(moment().subtract(7, "days")),
          value: this.getMondayString(moment().subtract(7, "days")),
        },
        {
          text: this.getWeekString(moment()),
          value: this.getMondayString(moment()),
        },
        {
          text: this.getWeekString(moment().add(7, "days")),
          value: this.getMondayString(moment().add(7, "days")),
        },
        {
          text: this.getWeekString(moment().add(14, "days")),
          value: this.getMondayString(moment().add(14, "days")),
        },
        {
          text: this.getWeekString(moment().add(21, "days")),
          value: this.getMondayString(moment().add(21, "days")),
        },
        {
          text: this.getWeekString(moment().add(28, "days")),
          value: this.getMondayString(moment().add(28, "days")),
        },
        {
          text: this.getWeekString(moment().add(35, "days")),
          value: this.getMondayString(moment().add(35, "days")),
        },
        {
          text: this.getWeekString(moment().add(42, "days")),
          value: this.getMondayString(moment().add(42, "days")),
        },
      ],
    };
  }

  constructor() {
    super();
    this.$axios.get("tutorials/get_capacity/").then((response) => {
      const capacities: any[] = response.data;
      for (const capacity of capacities) {
        this.capacityDict[capacity.id] = capacity;
      }

      this.$axios.get("tutors/get_name_id/").then((response) => {
        for (const tutor of response.data) {
          this.tutors.push(tutor);
        }
      });
    });
  }

  intervalFormat(interval: any) {
    return interval.time + " - " + this.addHoursToTime(interval.time, 2);
  }

  showLabel() {
    return true;
  }

  addHoursToTime(time: string, hours: number) {
    const timeArray = time.split(":");
    if (timeArray.length == 2) {
      const hour = parseInt(timeArray[0]) + hours;
      return hour + ":" + timeArray[1];
    }
  }

  moment() {
    return moment();
  }
  getMondayString(day: moment.Moment): string {
    return day.startOf("isoWeek").format("YYYY-MM-DD");
  }

  getWeekString(day: moment.Moment): string {
    return (
      day.startOf("isoWeek").format("DD.MM.YYYY") +
      " - " +
      day.endOf("week").subtract(1, "day").format("DD.MM.YYYY")
    );
  }

  dateStringTransform(dateString: string, weekday: number): string {
    const dateStringArray = dateString.split("-");
    if (dateStringArray.length && dateStringArray[2]) {
      const day = parseInt(dateStringArray[2]) + weekday;
      if (day < 10) {
        return "0" + day + "." + dateStringArray[1] + "." + dateStringArray[0];
      } else {
        return day + "." + dateStringArray[1] + "." + dateStringArray[0];
      }
    } else {
      return dateString;
    }
  }

  @Watch("selectedWeek")
  onPropertyChanged(value: string, oldValue: string) {
    this.sessionsWeek = [];
    this.$axios
      .get("tutor_sessions/get_week/", {
        params: { group: value },
      })
      .then((response) => {
        const sessionsWeekTemp: TutorSession[] = response.data;
        sessionsWeekTemp.sort(function (a, b) {
          const nameA = a.name.toUpperCase(); // Groß-/Kleinschreibung ignorieren
          const nameB = b.name.toUpperCase(); // Groß-/Kleinschreibung ignorieren
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // Namen müssen gleich sein
          return 0;
        });
        const sessionsWeekDictTemp: { [key: string]: TutorSession[] } = {};
        sessionsWeekTemp.map((tutorial) => {
          if (sessionsWeekDictTemp[tutorial.day]) {
            sessionsWeekDictTemp[tutorial.day].push(tutorial);
          } else {
            sessionsWeekDictTemp[tutorial.day] = [tutorial];
          }
        });
        this.sessionsWeekDict = sessionsWeekDictTemp;
        for (const session of sessionsWeekTemp) {
          this.sessionsWeek.push(session);
        }
      });
  }
}
